import * as R from 'ramda';
import { CaseGranulometry } from '../../CaseGranulometry';
import { getCaseTopLevelsCeilingHeights } from './getCaseTopLevelsCeilingHeights';

export const getCaseTopLevelsAverageHeight = (caseGranulometry: CaseGranulometry): number =>
  R.mean(getCaseTopLevelsCeilingHeights(caseGranulometry));
